<template>
    <div class="mapa-editor-container" :style="props.estilos?.container">
        <slot name="overlaySelecao" />
        <div class="mapa-frame-wrapper" v-if="iframeHtml" :key="iframeHtml" v-html="iframeHtml"></div>
        <div v-else class="mapa-placeholder">
            <span>Insira uma URL do Google Maps para exibir o mapa.</span>
        </div>
    </div>
</template>
<script setup>
import { defineProps, defineEmits, computed } from 'vue';

const props = defineProps({
    url: {
        type: String,
        default: '',
    },
    zoom: {
        type: Number,
        default: 15,
    },
    estilos: {
        type: Object,
        default: () => ({
            container: {
                borderRadius: '8px',
                border: '1px solid #eee',
                boxShadow: 'none',
                height: '50%',
                background: '#fff',
            },
        }),
    },
});

const emit = defineEmits(['update:props']);

const iframeHtml = computed(() => {
    if (!props.url || !props.url.includes('@')) {
        return null;
    }

    try {
        const coordsMatch = props.url.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);
        if (coordsMatch && coordsMatch.length >= 3) {
            const lat = coordsMatch[1];
            const lng = coordsMatch[2];
            const embedUrl = `https://maps.google.com/maps?q=${lat},${lng}&hl=pt-BR&z=${props.zoom}&output=embed`;
            return `<iframe src="${embedUrl}" width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy"></iframe>`;
        }
    } catch (error) {
        console.error('Erro ao processar URL do mapa:', error);
    }

    return null;
});

const propsAtualizados = computed(() => ({
    url: props.url,
    zoom: props.zoom,
    estilos: props.estilos,
}));

emit('update:props', { ...propsAtualizados.value });
</script>
<style scoped>
.mapa-editor-container {
    width: 100%;
    height: 100%;
    min-height: 80px;
    max-height: 100%;
    display: flex;
    align-items: stretch;
    justify-content: stretch;
    position: relative;
    box-sizing: border-box;
    overflow: hidden;
    background: #fff;
    border-radius: 8px;
}
.mapa-frame-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: stretch;
    justify-content: stretch;
}
.mapa-frame-wrapper iframe {
    width: 100% !important;
    height: 100% !important;
    max-width: 100%;
    max-height: 100%;
    border-radius: 8px;
    background: #eaf6fb;
    object-fit: cover;
    min-height: 60px;
    display: block;
}
.mapa-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #f8f9fa;
    color: #6c757d;
    text-align: center;
    padding: 20px;
    gap: 10px;
}
</style>
